<template>
    <div class="w-100"> 
        <importador-cotizaciones-tabla />
    </div>
</template>

<script>
import { mapActions } from 'vuex';

import ImportadorCotizacionesTabla from '../../../components/tablas/lineas/ImportadorCotizacionesTabla.vue';

export default {
    
    data() {
        return {};
    },
    props: {},

    components: {ImportadorCotizacionesTabla},

    created() {
        this.actualizarURL();
    },

    mounted() {},

    methods: {

        ...mapActions(["AccionCambiar"]),

        actualizarURL() {
            let me = this;
            me.AccionCambiar(this.$route.path);
        },
    },

    computed: {},

    watch: {},

    directives: {},

    filters: {}
};
</script>

